import { CustomersPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import CUSTOMERS_ICON from "@redotech/redo-icons/face-content.svg";
import CUSTOMERS_ICON_FILLED from "@redotech/redo-icons/face-content_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { LinkPrimaryTab } from "@redotech/redo-web/arbiter-components/navigation/primary/redo-primary-nav";
import { PageNavigationEntry } from "@redotech/redo-web/arbiter-components/navigation/redo-side-navigation";

export function useCustomersNavigation(): PageNavigationEntry | null {
  const routes = useRequiredContext(MerchantRoutesContext);

  const canViewCustomers = useHasPermission(
    CustomersPermissions.VIEW_CUSTOMER_RECORD,
  );

  if (!canViewCustomers) {
    return null;
  }

  const baseUrl = routes.customersBaseUrl;
  const primaryUrl = routes.getCustomerRecordHref({ customerId: undefined });

  const primaryTab: LinkPrimaryTab = {
    id: "customer",
    hasNotification: false,
    UnfilledIcon: CUSTOMERS_ICON,
    FilledIcon: CUSTOMERS_ICON_FILLED,
    type: "link",
    pathRoot: baseUrl,
    href: primaryUrl,
    friendlyName: "Customers",
  };

  // TODO: Eventually analytics should live here and we will need secondary nav
  // const secondaryNavigationData: SecondaryNavigationData = {
  //   id: "customer",
  //   name: "Customers",
  //   NavContent: SecondaryCustomersSection,
  // };

  return { primaryTab, secondaryNavigationData: undefined };
}
